import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';

export const StyledContainer = styled('div')(() => ({
  margin: '0 auto',
  marginTop: '72px',
  background: 'white',
  width: '100%',
  maxWidth: '1265.48px',
  borderRadius: '5px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)',
  transition: 'box-shadow 0.3s ease, transform 0.2s ease',
}));

export const StyledHeaderGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.grey[400]}`,
  padding: '1.5%',
  flexDirection: 'row',
}));

export const StyledButtonGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
}));

export const StyledIconGrid = styled(Grid)(() => ({
  display: 'flex',
  marginRight: '6px',
  alignItems: 'center',
  cursor: 'pointer',
  marginTop: '10px',
}));

export const StyledTypography = styled(Typography)(() => ({
  marginTop: '3px',
  marginRight: '6px',
  fontSize: '10.25px',
  lineHeight: '10.85px',
}));

export const PriceNote = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '8.17px',
  lineHeight: '9.96px',
  fontStyle: 'italic',
}));

export const ReviewScenarioBtnText = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '15.43px',
  lineHeight: '18.81px',
}));

export const NoOfIntervention = styled(Typography)(() => ({
  borderRadius: '50%',
  color: 'white',
  width: '25px',
  height: '25px',
  fontWeight: 700,
  fontSize: '10.52px',
  lineHeight: '19.17px',
  marginLeft: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
}));

export const StyledMainContentGrid = styled(Grid)(() => ({
  display: 'flex',
  marginTop: '15px',
  padding: 0,
  margin: 0,
}));

export const StyledLeftColumn = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',

  padding: 0,
  margin: 0,
}));

export const StyledRightColumn = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '15px',
  padding: 0,
  margin: 0,
}));

export const StyledIconImage = styled('img')(() => ({
  marginRight: '6px',
}));

export const StyledSegmentSelectionGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
